import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {loginItem, loginItemList} from '../../_animations/loginAnimations';
import {FileUploader} from 'ng2-file-upload';
import {filetypeinfo} from 'magic-bytes.js';
import {DicomParserHelper} from '../../_services/dicom/dicom-parser.helper';
import {RequestFileService} from '../../_services/api/request-file.service';
import {ActivatedRoute} from '@angular/router';
import {HttpEvent, HttpEventType} from '@angular/common/http';

export interface UploadFile{
  anonymizationStatus: number;
  type: 'folder' | 'file';
  name: string;
  fileToProcess: any;
  fileAnonymised: File[];
  size: number;
  id: string;
  issueFiles?: string[];
}

@Component({
  selector: 'app-upload-requested-files',
  templateUrl: './upload-requested-files.component.html',
  styleUrls: ['./upload-requested-files.component.scss', '../../../loginForm.scss', '../../../inputGroup.scss'],
  animations: [loginItemList, loginItem]
})
export class UploadRequestedFilesComponent implements OnInit {

  loading: boolean;
  processingFiles: boolean;
  formEmpty: boolean;

  status: 'upload' | 'error' | 'expired' | 'bad_token' | 'validate_email' | 'done' | 'uploading';
  emailForm: FormGroup;
  uploadMessageForm: FormGroup;
  message: string;
  messageType: string;
  receiverEmail: string;
  ownerEmail: string;

  public uploader: FileUploader = new FileUploader({});
  filesToUpload: UploadFile[];
  allFiles: number;
  token: string;
  uploadProgress: number;
  createZipProgress: number;
  patientMessage: string;
  totalSizeExceeded: boolean;

  @ViewChild('uploadInput') uploadInput: ElementRef;
  @ViewChild('folderInput') folderInput: ElementRef;

  constructor(private formBuilder: FormBuilder, private dicomParser: DicomParserHelper, private requestFile: RequestFileService,
              private activatedRoute: ActivatedRoute) {
    this.loading = true;
    this.processingFiles = false;
    this.formEmpty = true;
    this.patientMessage = '';
    this.ownerEmail = '';
    this.uploadProgress = 0;
    this.createZipProgress = 0;
    this.filesToUpload = [];
    this.allFiles = 0;
    this.totalSizeExceeded = false;
    this.status = 'bad_token';
  }

  ngOnInit(): void {
    // this.requestFile.validate()
    this.activatedRoute.params.subscribe(params => {
      this.token = params.token;
      this.requestFile.exists(this.token).subscribe( res => {
        this.loading = false;
        this.status = 'validate_email';
        // this.status = 'upload';
      }, error => {
        this.loading = false;
        this.status = 'bad_token';
      });
    });

    this.emailForm = this.formBuilder.group(
      {
        email: ['', [
          Validators.required, Validators.email
        ]],
      }
    );

    this.emailForm.get('email').valueChanges.subscribe(event => {
      this.emailForm.get('email').setValue(event.toLowerCase(), {emitEvent: false});
    });

    this.uploadMessageForm = this.formBuilder.group({
      patientMessage: [''], }
    );
  }

  validateEmail(){
    this.loading = true;
    this.requestFile.validate(this.token, this.emailForm.value).subscribe( res => {
      if (res.uuid){
        this.receiverEmail = res.owner_email;
        this.ownerEmail = res.email;
        this.status = 'upload';
        this.loading = false;
      } else {
        this.message = 'Provided email is incorrect';
        this.messageType = 'danger';
        this.loading = false;
      }
    });
  }

  reload(){
    window.location.reload();
  }

  private createNewName(name: string, n: number): string{
    let nameList = name.split('.');
    if (nameList.length > 1){
      nameList[nameList.length - 2] += ' (' + n.toString() + ')';
    } else {
      nameList[0] += ' (' + n.toString() + ')';
    }
    return nameList.join('.');
  }

  private checkIfNameExistsAndCreateNewOne(name: string, n?: number, tempName?: string): string {
    const currentNames = this.filesToUpload.map(x => x.name);
    const currentCount = n ? n : 0;
    const nameToCheck = tempName ? tempName : name;
    if (currentNames.indexOf(nameToCheck) > -1){
      const displayCount = currentCount + 1;
      return this.checkIfNameExistsAndCreateNewOne(name, displayCount, this.createNewName(name, displayCount));
    }
    return nameToCheck;
  }

  uploadDicoms(files, event) {

    const fileToProcess = {};
    let totalSize = 0;
    let changeFilePath = false;
    let name = '';

    Object.keys(files).forEach( x => {
      if (x === '0'){
        name = files[x].webkitRelativePath.split('/')[0];
        const folderName = this.checkIfNameExistsAndCreateNewOne(name);
        if (folderName !== name){
          changeFilePath = true;
          name = folderName;
        }
      }
      const file = files[x];
      const fileId = Math.random().toString(36).slice(2, 7);
      fileToProcess[fileId] = file;
      totalSize += file.size;
    });

    const fileToUpload: UploadFile = {
      size: totalSize,
      name,
      fileToProcess,
      issueFiles: [],
      fileAnonymised: [],
      anonymizationStatus: 0,
      type: 'folder',
      id: Math.random().toString(36).slice(2, 7)};
    this.processingFiles = true;
    this.filesToUpload.push(fileToUpload);

    this.processFiles(fileToUpload);
    event.target.value = null;

  }

  uploadDicom(event){
    const files = this.uploader.queue;
    this.uploader.queue = [];

    files.forEach( x => {
      const fileToProcess = {};
      const fileId = Math.random().toString(36).slice(2, 7);
      fileToProcess[fileId] = x.file.rawFile;

      const fileToUpload: UploadFile = {
        size: x.file.size,
        name: this.checkIfNameExistsAndCreateNewOne(x.file.name),
        fileToProcess,
        issueFiles: [],
        fileAnonymised: [],
        anonymizationStatus: 0,
        type: 'file',
        id: Math.random().toString(36).slice(2, 7)};

      this.processingFiles = true;
      this.filesToUpload.push(fileToUpload);

      this.processFiles(fileToUpload);
    });
  }

  clickOnUploadDicom(){
    this.uploadInput.nativeElement.click();
  }

  clickOnUploadDicoms(){
    this.folderInput.nativeElement.click();
  }

  processFiles(fileToUpload: UploadFile) {
    for (const [key, value] of Object.entries(fileToUpload.fileToProcess)) {
      this.processFile(value, key, fileToUpload.id);
    }
  }

  processFile(file, fileId, fileToUploadId){
    const filereader = new FileReader();

    filereader.onloadend = (f) => {
      if (f.target.result instanceof ArrayBuffer) {
        const bytes = new Uint8Array(f.target.result);
        const fti = filetypeinfo(bytes);
        if (fti.some(item => item.typename === 'dcm') ||
          (file.name.substr(file.name.length - 4) === '.nii' && fti.length === 0) ||
          (file.name.substr(file.name.length - 4) === '.stl' && (fti.length === 0 || fti.some(item => item.typename === 'pdb'))) ||
          (file.name.substr(file.name.length - 4) === '.obj' && fti.length === 0) ||
          (fti.some(item => item.typename === 'tar.gz') && file.name.substr(file.name.length - 7) === '.nii.gz'))    {
          this.anonymizeDicom(file, fileId, fileToUploadId);
        } else {
          const ftu = this.filesToUpload.find( x => x.id === fileToUploadId);
          ftu.issueFiles.push(ftu.fileToProcess[fileId].name);
          delete ftu.fileToProcess[fileId];
          if (Object.keys(ftu.fileToProcess).length === 0){
            this.validateFiles();
          }
        }
      }
    };

    filereader.readAsArrayBuffer(file);
  }

  dropped(e: any){
    console.log(e);
  }

  returnProperFilePath(folderName: string, fullPath: string): string{
    const splitted = fullPath.split('/');
    if (splitted[0] !== folderName){
      splitted[0] = folderName;
    }
    return splitted.join('/');
}

  anonymizeDicom(file, fileId, fileToUploadId){
    this.allFiles += 1;
    const fileNumber = this.allFiles;

    file.arrayBuffer().then(buff => {
      this.dicomParser.anonymizeFileInWebWorkerAndReturnArrayBuffer(buff, fileNumber, file.name, fileId + '_' + fileToUploadId).subscribe(res => {
        const resQueueId: string = res[2];
        const resFileToUploadId = resQueueId.split('_')[1];
        const resFileId = resQueueId.split('_')[0];
        const blob = new Blob([res[0]]);

        const ftu = this.filesToUpload.find( x => x.id === resFileToUploadId);
        const path = file.webkitRelativePath === '' ? ftu.name : this.returnProperFilePath(ftu.name, file.webkitRelativePath);

        ftu.fileAnonymised.push(new File([blob], path, {lastModified: new Date().getTime()}));
        delete ftu.fileToProcess[resFileId];

        if (Object.keys(ftu.fileToProcess).length === 0){
          this.validateFiles();
        }
      });
    }, error => {
      console.log(error);
    });
  }

  deleteFileToUpload(id: string){
    this.filesToUpload = this.filesToUpload.filter( x => x.id !== id);
    this.validateFiles();
  }

  validateFiles(){
    this.processingFiles = this.filesToUpload.map(x => Object.keys(x.fileToProcess).length).reduce((partialSum, a) => partialSum + a, 0) > 0;
    this.formEmpty = this.filesToUpload.map(x => x.fileAnonymised.length).reduce((partialSum, a) => partialSum + a, 0) === 0;
    this.totalSizeExceeded = this.filesToUpload.map(x => x.fileAnonymised.map(y => y.size).reduce((partialSum, a) => partialSum + a, 0)).reduce((partialSum, a) => partialSum + a, 0) > 3221226472;
  }

  createZip(){
    this.status = 'uploading';
    // @ts-ignore
    const fileList = this.filesToUpload.map( x => x.fileAnonymised).flat();

    const numberOfFiles = fileList.length;
    const filesSize = this.filesToUpload.map( x => x.size).reduce((a, b) => a + b, 0).toString();

    const qid = new Date().getTime().toString() + '_' + Math.random().toString(36).slice(2, 7);

    this.dicomParser.createZip(fileList, 'test' + '.zip', 'id', qid).subscribe(res => {
      if (res[0] instanceof Blob) {
        const resQueueId: string = res[1];

        const form = new FormData();
        form.append('file' , res[0], resQueueId + '.zip');
        form.append('email', this.ownerEmail);
        form.append('files_size', filesSize);
        form.append('number_of_files', numberOfFiles);
        if (this.uploadMessageForm.controls.patientMessage.value.length > 0){
          form.append('patient_message', this.uploadMessageForm.controls.patientMessage.value);
        }

        this.requestFile.upload(this.token, form).subscribe(
          (event: HttpEvent<any>) => {
            switch (event.type) {
              case HttpEventType.UploadProgress:
                this.uploadProgress = event.loaded / event.total;
                break;
              case HttpEventType.Response:
                this.status = 'done';
                break;
            }
          }, error => {
            console.log(error);
            this.status = 'error';
          });

      } else if (res.status === 'update') {
       this.createZipProgress = res.progress;
      }
    }, error => {});
  }

}
